import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-shared-dialog',
  templateUrl: './shared-dialog.component.html',
  styleUrls: ['./shared-dialog.component.scss']
})
export class SharedDialogComponent {
  title: string;
	message: string;

	constructor(
		private dialog_ref: MatDialogRef<SharedDialogComponent>,
		@Inject(MAT_DIALOG_DATA) data: any,
	) {
		this.title = data.title;
		this.message = data.message;
	}

	onCloseClick(): void {
		this.dialog_ref.close();
	}
}
